<template>
    <div class="page">
        <div class="page-bd max">
            <div class="edit-box">
                <div class="f-bd f14 text-nowrap">{{$t('add_time')}}{{$t('x_mh')}}</div>
                <div class="mg-right10"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right10">
                    <Input v-model="search.search_text" :placeholder="$t('code_cname')">
                        <span slot="prepend">{{$t('user')}}{{$t('x_yd')}}</span>
                    </Input>
                </div>
                <div class="mg-right10"><Button type="primary" @click="openAdd">{{$t('add_new_user')}}</Button></div>
                <div class="mg-right10"><Button type="primary" @click="list(false)">{{$t('list')}}</Button></div>
                <!-- <div class="mg-right10"><Button type="success" @click="exportExcel">{{$t('export')}}</Button></div> -->
            </div>
            <div class="table-box">
                <div class="table-box-header mini-scrollbar" ref="table_box_header" style="overflow-y: scroll">
                    <Row class="table-tr th">
                        <Col class="table-td" style="width:5%">{{listHeader.img_lnk}}</Col>
                        <Col class="table-td" style="width:5%">{{listHeader.user_code}}</Col>
                        <Col class="table-td" style="width:5%">{{listHeader.user_cname}}</Col>
                        <Col class="table-td" style="width:5%">{{listHeader.user_sex_name}}
                            <myDropdown :list="user_sexs" v-model="search.user_sex"
                                    key_name="value" value_name="key"
                                    @onChange="onTypesChange"></myDropdown>
                        </Col>
                        <Col class="table-td" style="width:10%">{{listHeader.roles}}</Col>
                        <Col class="table-td" style="width:10%">{{listHeader.deps}}</Col>
                        <Col class="table-td" style="width:10%">{{listHeader.user_mobile}}</Col>
                        <Col class="table-td" style="width:10%">{{listHeader.user_birth}}</Col>
                        <Col class="table-td" style="width:10%">{{listHeader.add_time}}</Col>
                        <Col class="table-td" style="width:20%">{{$t('op')}}</Col>
                        <Col class="table-td" style="width:10%">{{$t('down_role')}}</Col>
                    </Row>
                </div>
                <div class="table-box-content mini-scrollbar" ref="table_box_content" style="overflow-x: hidden" :style="table_box_content_style" @scroll="$base.setTableBoxContentScroll(self,false)">
                    <myNodata v-show="totalData.total <= 0" :last_time="search.search_time"></myNodata>
                    <Row class="table-tr even-line-bcolor" type="flex" align="middle" v-for="(item,index) in listData" :key="item.u_id">
                        <Col class="table-td" style="width:5%">
                            <myImgshow :src="item.img_lnk" @onClick="openImg(item.img_lnk,item.user_code)"></myImgshow>
                        </Col>
                        <Col class="table-td" style="width:5%">{{item.user_code}}</Col>
                        <Col class="table-td" style="width:5%">{{item.user_cname}}</Col>
                        <Col class="table-td" style="width:5%">{{item.user_sex_cname}}</Col>
                        <Col class="table-td" style="width:10%">
                            <span v-for="(item2, index2) in item.roles" :key="index2">
                                <Tag color="geekblue">{{item2.role_cname}}</Tag>
                            </span>
                        </Col>
                        <Col class="table-td" style="width:10%">{{item.dep_cname}}
                        <span v-for="(item3, index3) in item.deps" :key="index3">
                                <Tag color="magenta">{{item3.dep_cname}}</Tag>
                            </span>
                        </Col>
                        <Col class="table-td" style="width:10%">{{item.user_mobile}}</Col>
                        <Col class="table-td" style="width:10%">{{item.user_birth}}</Col>
                        <Col class="table-td" style="width:10%">{{item.add_time}}</Col>
                        <Col class="table-td" style="width:20%">
                            <a @click="openSave(item)">{{$t('info')}}</a>
                            <a @click="removeUser(item.u_id)">{{$t("remove_self")}}</a>
                            <a class="f-red" @click="removeUserAll(item.u_id)" v-if="$base.getOrgLevel() != '3'">{{$t("remove_org_all")}}</a>
                            <a @click="resetPassword(item.u_id)">{{$t("reset_pwd")}}</a>
                            <!-- <a @click="openEwm(item)">二维码</a> -->
                        </Col>
                        <Col class="table-td" style="width:10%" v-if="['1', '2'].includes($base.getOrgLevel())">
                            <a @click="setdownrole(item)">{{$t('setup')}}</a>
                            <a @click="listdownrole(item)">{{$t('list')}}</a>
                        </Col>
                        <Col class="table-td" style="width:10%" v-else>/</Col>
                    </Row>
                </div>
                <div class="table-pager" v-show="totalData.total > 0">
                    <myPager :limit="search.limit" @onLimitChange="onLimitChange"
                             v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
                </div>
            </div>
        </div>
        <!-- <download-excel :data="excelData" :fields="exportHeader" :name="export_title" v-show="false">
            <a type="success" ref="btn_excel"></a>
        </download-excel> -->
        <Drawer class="drawer-sub-view" :title="sub_title" v-model="show_subview" width="850" :mask-closable="false" placement="left" :closable="false">
            <router-view></router-view>
        </Drawer>
    </div>
</template>

<script>
    import myDatePicker from '../../../components/myDatePicker'
    import myPager from '../../../components/myPager'
    import myNodata from '../../../components/myNodata'
    import myImgshow from '../../../components/myImgshow'
    import myDropdown from '../../../components/myDropdown'
    export default {
        name:"org-user",
        components:{
            myDatePicker,
            myPager,
            myNodata,
            myImgshow,
            myDropdown,
        },
        data:function(){
            const listHeader = {
                img_lnk: this.$t('img_lnk'),
                user_code: this.$t('user_code'),
                user_cname: this.$t('user_cname'),
                user_sex_cname: this.$t('sex'),
                roles: this.$t('role'),
                deps: this.$t('dep'),
                user_mobile: this.$t('org_mobile'),
                user_birth: this.$t('birth'),
                add_time: this.$t('add_time'),
            };
            return{
                self:this,
                table_box_content_style: {
                    height:"200px"
                },
                table_box_content_fixed_style: {
                    height:"200px"
                },
                title: this.$t('user'),
                export_title: '',
                sub_title:"",//子界面名称
                show_subview:false,
                relist:false,
                user_sexs:[
                    {
                        key:'',
                        value:this.$t('all')
                    }
                ],
                search:{
                    search_url: "user/list",
                    search_time: new Date(),//最新查询时间
                    search_text: "",
                    date_fr: '',
                    date_to: '',
                    page: 1,
                    limit: 30,
                    pageSize: 0,
                    user_sex:''
                },
                listHeader,//表结构
                listData: [],
                excelData: [],
                exportHeader : this.$base.changeJsonKeyValue(listHeader),
                totalData: {
                    total: 0,//总行数
                }
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.setTable()
            for(var key in this.exportHeader) {
                if(this.exportHeader[key] == 'roles') {
                    this.exportHeader[key] = {
                        field: this.exportHeader[key],
                        callback: data => {
                            var s = "";
                            for(var i=0;i<data.length;i++){
                                s += data[i].role_cname + '\n';
                            }
                            return s;
                        }
                    }
                }
                if(this.exportHeader[key] == 'deps') {
                    this.exportHeader[key] = {
                        field: this.exportHeader[key],
                        callback: data => {
                            var s = "";
                            for(var i=0;i<data.length;i++){
                                s += data[i].dep_cname + '\n';
                            }
                            return s;
                        }
                    }
                }
            }
            this.getLoad()
        },
        methods:{
            setTable () {
                var table_box_height = this.$base.getTableBoxHeight(this.$refs['table_box_content']);
                this.table_box_content_style.height = table_box_height + 'px';
                table_box_height -= 10;
                this.table_box_content_fixed_style.height = table_box_height + 'px';
            },
            getLoad: function() {
                var data = {};
                this.$base.showLoading();
                this.$request.sendPost("user/before-list",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.user_sexs = this.user_sexs.concat(data.sexs);
                        this.list();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
                this.list();
            },
            onTypesChange:function () {
                this.list();
            },
            onSearchTextChange: function(data){
                this.list();
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            list: function (change_page) {
                if(!change_page) this.search.page = 1;
                this.search.search_time = new Date();
                this.$base.showLoading();
                this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.listData = data.list;
                        this.search.pageSize = parseInt(data.last_page);
                        this.totalData.total = data.total.total;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            exportExcel: function(){
                this.$base.exportExcel(this);
            },
            openImg: function(src, title){
                this.$base.alertImg(src, title,"500px")
            },
            openAdd:function (id) {
                this.sub_title = this.$t('add_new_user');
                this.$base.linkTo('user/add');
            },
            openSave:function (item) {
                this.sub_title = this.$t('upd_new_user');
                this.$base.linkTo('user/upd',{data: JSON.stringify(item)});
            },
            removeUser: function (user_id) {
                let data = {
                    u_id: user_id,
                };
                let content = this.$t('confirm_remove');
                let title =  this.$t('tips');
                this.$base.confirm(title,content, () => {
                    this.$base.showLoading();
                    this.$request.sendPost("user/del",data,(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.list();
                        }
                        else{
                            this.$base.msgErr(error.errmsg);

                        }
                    });
                },()=>{})
            },
            removeUserAll: function (user_id) {
                let data = {
                    u_id: user_id,
                };
                let content = this.$t('confirm_remove');
                let title =  this.$t('tips');
                this.$base.confirm(title,content, () => {
                    this.$base.showLoading();
                    this.$request.sendPost("user/del-all",data,(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.list();
                        }
                        else{
                            this.$base.msgErr(error.errmsg);
                        }
                    });
                },()=>{})
            },
            resetPassword: function (id) {
                if (!id) {
                    this.$base.alertErr(this.$t('no_user'));
                    return;
                }
                this.sub_title = this.$t('reset_pwd');
                this.$base.linkTo('user/resetPwd',{id: id});
            },
            setdownrole: function (item) {
                this.sub_title = this.$t('down_role');
                this.$base.linkTo('user/setdownrole',{user_code: item.user_code, user_cname: item.user_cname,u_id: item.u_id});
            },
            listdownrole: function (item) {
                this.sub_title = this.$t('down_role');
                this.$base.linkTo('user/listdownrole',{user_code: item.user_code, user_cname: item.user_cname,u_id: item.u_id});
            },
            openEwm:function (item) {
                this.sub_title = "用户二维码";
                this.$base.linkTo('user/ewm',{user_code: item.user_code, img_lnk: item.img_lnk,
                    user_cname: item.user_cname, user_mobile: item.user_mobile})
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(this.search.page);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/user/user.vue